import { Stack, Box } from 'braid-design-system';

import { PostType } from 'src/graphql/__generated__';
import type { DraftJob } from 'src/types';

import { CardMobileView } from '../CardMobileView';
import { DraftJobActions } from '../JobActions/DraftJobActions/DraftJobActions';
import { JobStatus } from '../JobStatus/JobStatus';
import { JobTitleAndLocation } from '../JobTitleAndLocation/JobTitleAndLocation';

interface Props {
  draftJobs: DraftJob[];
  loading?: boolean;
}

export const DraftListMobile = ({ draftJobs, loading = false }: Props) => (
  <Stack space="small">
    {draftJobs.map((draft) => (
      <CardMobileView key={draft.draftId}>
        <Stack space="large">
          <JobStatus isDraft={true} loading={loading} status={draft.status} />

          <JobTitleAndLocation
            id={draft.draftId}
            isDraft={true}
            advertiserReference={draft.advertiserReference}
            createdDate={draft.createdDate}
            createdBy={draft.createdBy}
            title={draft.title}
            location={draft.location}
            loading={loading}
            postType={PostType.DIRECT}
          />

          <Box display="flex" alignItems="flexStart">
            <DraftJobActions draftId={draft.draftId} loading={loading} />
          </Box>
        </Stack>
      </CardMobileView>
    ))}
  </Stack>
);
